import vendorSidebarItems from "@/layouts/Vendor/sidebarItems";

export default {
  path: "/vendor",
  component: () => import("@/layouts/main.vue"),
  redirect: { name: "vendor-assignments" },
  meta: {
    authRequired: true,
    verificationRequired: true,
    roles : ["administrator", "vendor"],
    sidebarItems: vendorSidebarItems,
    sidebarTitle: "Vendor",
  },
  children: [
    {
      path: "assignments",
      name: "vendor-assignments",
      meta: {
        title: "Penugasan Vendor",
        authRequired: true,
        sidebarItems: vendorSidebarItems,
        sidebarTitle: "Vendor",
      },
      component: () => import("../views/custom/vendor/assignments/index.vue"),
    },
    {
      path: "assignments/:id",
      name: "vendor-assignments-detail",
      meta: {
        title: "Detail Penugasan",
        authRequired: true,
        sidebarItems: vendorSidebarItems,
        sidebarTitle: "Vendor",
      },
      component: () => import("../views/custom/vendor/assignments/detail.vue"),
    },
    {
      path: "progress-report",
      name: "vendor-progress-report",
      meta: {
        title: "Laporan Progres",
        authRequired: true,
        sidebarItems: vendorSidebarItems,
        sidebarTitle: "Vendor",
      },
      component: () => import("../views/custom/vendor/progress-report/index.vue"),
    },
  ],
};

